import sendings from '@sigma-frontend-libs/messages/en/sendings'

export default {
  title: 'Financial report',

  labels: {
    id: 'ID',
    owner: 'Owner',
    action: 'Action',
    source: 'Source',
    amount: 'Amount',
    multiplier: 'Multiplier',
    comment: 'Comment',
    preset: 'Preset',
    status: 'Status',
    tariff: 'Tariff',
    noRef: 'Non-referral',
    price: 'Price',
    TariffId: 'Tariff',
    total: 'Total',
    priceCalculation: 'Price calculation',

    Owner: {
      id: 'Owner'
    },

    count: {
      pending: 'Pending {count}',
      refunded: 'Refunded {count}',
      complete: 'Complete {count}',
      invalid: 'Invalid {count}',
      total: 'Total {count}'
    },

    ref: {
      true: 'Referral',
      false: 'Non-referral',
      undefined: 'Not specified'
    },

    data: {
      price: 'Price',
      multiplier: 'Multiplier',

      priceCalculation: {
        price: 'Price',
        size: 'Size',
        spent: 'Used',
        counter: 'Counter',
        segmentPrice: 'Price',
        segmentCount: 'Segments',
        threshold: 'Threshold',
        sum: 'Subtotal',

        types: {
          packet: 'Packet',
          range: 'Range'
        }
      }
    }
  },

  headers: {
    status: 'Status',
    owner: 'Owner',
    creator: 'Creator',
    source: 'Type',
    tariff: 'Tariff',
    comment: 'Comment',
    amount: 'Amount',
    total: 'Total',
    title: 'Title',
    frequency: 'Frequency',
    count_pending: 'Pending',
    sum_pending: 'Pending (sum)',
    count_refunded: 'Refunded',
    sum_refunded: 'Refunded (sum)',
    count_complete: 'Complete',
    sum_complete: 'Complete (sum)',
    count_invalid: 'Invalid',
    sum_invalid: 'Invalid (sum)',
    count_total: 'Total',
    sum_total: 'Total (sum)',
    referrer: 'Referrer'
  },

  dialogs: {
    create: 'Create a new billing operation'
  },

  actions: {
    addFunds: 'Add funds',
    charge: 'Write off funds'
  },

  hints: {
    date: {
      from: 'YYYY-MM-DD',
      by: 'YYYY-MM-DD'
    },
    time: {
      from: 'HH:MM',
      by: 'HH:MM'
    },
    empty: 'To get data use the filter.'
  },

  presets: {
    billings: {
      details: 'Detailed report on billing operations',
      group001: 'Grouping by source'
    }
  },

  report: {
    download: 'Download',
    get: 'Get report'
  },

  statuses: {
    pending: 'Pending',
    refunded: 'Refunded',
    complete: 'Complete',
    invalid: 'Invalid'
  },

  buttons: {
    clear: 'Clear filter',
    refresh: 'Refresh'
  },

  tooltips: {
    refresh: 'Refresh table data using the selected filter.',
    actions: 'Top up or write off the balance'
  },

  tabs: {
    billings: 'Financial report',
    tasks: 'Tasks'
  },

  sources: {
    ...sendings.types,
    subtract: 'Write-off',
    accrual: 'Top up'
  },

  snackbars: {
    created: 'Billing operation successfully created.',
    updated: 'Billing operation successfully updated.',
    removed: 'Billing operation successfully removed.',
    funds: {
      success: 'Funds successfully credited.',
      failed: 'Error crediting funds.'
    }
  },

  currency: {
    RUB: '₽ russian rubles',
    USD: '$ US dollars',
    EUR: '€ euros',
    MXN: 'MX$ mexican pesos'
  }
}
